// extracted by mini-css-extract-plugin
export var container = "ProductSpecificationsCard-module--container--AQTzO";
export var entry = "ProductSpecificationsCard-module--entry--m-k52";